import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatTableModule, MatRowDef } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import CompanyAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity";
import PriceListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/price-list/price-list.entity";
import PlantsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/plants/plants.entity";
import { CompanyService } from "../company/company.service.service";
import { PriceListService } from "../../master/price-list/price-list.service";
import { MatTabsModule } from "@angular/material/tabs";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent, NgSelectModule } from "@ng-select/ng-select";
import { DistributionChainService } from "./distribution-chain.service";
import { ICreateDistributionChain } from "./interfaces/create-distribution-chain.interface";
import { IUpdateDistributionChain } from "./interfaces/update-distribution-chain.interface";
import DistributionChainAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity";
import SalesOrganizationAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-organization/sales-organization.entity";
import ChannelAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/channel/channel.entity";
import { SalesOrganizationService } from "../sales-organization/sales-organization.component.service";
import { ChannelService } from "../channel/channel.component.service";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from "app/utils/method";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/status.enum";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";

@Component({
  selector: 'app-distribution-chain',
  standalone: true,
  templateUrl: './distribution-chain.component.html',
  styleUrl: './distribution-chain.component.scss',
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})
export class DistributionChainComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;

  displayedColumns: string[] = ["name","channel","salesOrganization", "company", "status", "actions"];
  currentCreateDistributionChain: ICreateDistributionChain = this.initializeCreateDistributionChain();
  currentUpdateDistributionChain: DistributionChainAttributes | undefined;

  dataSource: DistributionChainAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  
  channelList: ChannelAttributes[] = [];
  listFilterChannelList: ChannelAttributes[] = [];
  searchChannel = ''
  selectedTypeChannel = [] //filter

  salesOrganizationList: SalesOrganizationAttributes[] = [];
  selectedCompanyIds: string[] = [];
  plantList: PlantsAttributes[] = [];
  priceList: PriceListAttributes[] = [];
  discountList: PriceListAttributes[] = [];
  giftList: PriceListAttributes[] = [];
  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;
  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;
  
  //BUSCADOR
  searchSubscription: Subscription;

  form: FormGroup;
  selectedStatuses: number[] = [StatusEnum.ACTIVE];

  // Lazy loading
  loadFiltersData = false;
  private companiesLoaded = false;
  private channelsLoaded = false;
  private dataLoadedForModals = false;

  constructor(
    private readonly distributionChainService: DistributionChainService,
    private readonly salesOrganizationService: SalesOrganizationService,
    private readonly channelService: ChannelService,
    private readonly companyService: CompanyService,
    private readonly priceListService: PriceListService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private fb: FormBuilder 
  ) {
    this.form = this.fb.group({
      companyId: [],
      channelId:[]
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.fetchCompanies();
    }
  }

  private ensureChannelsLoaded(): void {
    if (!this.channelsLoaded) {
      this.fetchAllChannel();
    }
  }

  private ensureModalDataLoaded(): void {
    if (!this.dataLoadedForModals) {
      this.initializeComboBox();
      this.dataLoadedForModals = true;
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesLoaded();
    this.ensureChannelsLoaded();
  }

  private initializeCreateDistributionChain(): ICreateDistributionChain {
    return {
      name: "",
      companyId: "",
      salesOrganizationId: "",
      channelId: "",
      priceListId: "",
      discountListId: "",
      giftListId: "",
    };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }
  getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
    return selectedCompanyIds.map(
      (id) => this.companyList.find((group) => group._id.toString() === id)?.id
    );
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";
      // const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);

    let filter: IFilters = {
      status: this.selectedStatuses ? this.selectedStatuses : null,
      companyId: this.form.get("companyId")?.value,
      channelId: this.form.get("channelId")?.value,
    };

    this.distributionChainService
      .findAllWithCount({
        currentPage: pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
      },
      filter
    )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof DistributionChainAttributes {
    const validSortFields: (keyof DistributionChainAttributes)[] = ["name", "statusId"];
    return validSortFields.includes(
      this.sort.active as keyof DistributionChainAttributes
    )
      ? (this.sort.active as keyof DistributionChainAttributes)
      : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }
    
  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: DistributionChainAttributes): string {
    return item._id.toString();
  }

  initializeComboBox(){
    this.fetchCompanies();
    this.fetchPriceList();
    this.fetchAllDiscountPrice();
    this.fetchAllGiftPrice();
    this.fetchAllSalesOrganization();
    //this.fetchAllChannel();
  }

  private fetchAllSalesOrganization(): void {
    this.salesOrganizationService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOrganizationList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener organizaciones de ventas.","Cerrar",{ duration: 5000});
      },
    });
  }


  private fetchAllChannel(): void {
    this.channelService.findToComboBox().subscribe({
      next: (res) => {
        this.channelList = res.data;
        this.listFilterChannelList = this.channelList.slice();
        this.channelsLoaded = true;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener canales de distribución.","Cerrar",{ duration: 5000});
      },
    });
  }
  
  changeOptionsChannel(event): void{
    if (!this.channelList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterChannelList = this.channelList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterChannelList = this.channelList.filter(item => item.name.toLowerCase().indexOf(search) > -1)
  }

  private fetchAllDiscountPrice(): void {
    this.priceListService.findToComboBoxDiscountList().subscribe({
      next: (res) => {
        this.discountList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener descuentos de precios.","Cerrar",{ duration: 5000});
      },
    });
  }


  private fetchAllGiftPrice(): void {
    this.priceListService.findToComboBoxGiftList().subscribe({
      next: (res) => {
        this.giftList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener listas de regalos.","Cerrar",{ duration: 5000});
      },
    });
  }


  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      this.companiesLoaded = true;
    });
  }

  private fetchPriceList(): void {
    this.priceListService.findToComboBoxPriceList().subscribe((res) => {
      this.priceList = res.data;
    });
  }


  openCreateModal(): void {
    this.ensureModalDataLoaded();
    this.currentCreateDistributionChain = this.initializeCreateDistributionChain();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createDistributionChain());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(warehouse: DistributionChainAttributes): void {
    this.ensureModalDataLoaded();
    this.currentUpdateDistributionChain = { ...warehouse };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateDistributionChain(warehouse._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createDistributionChain(): void {
    const distributionChainData = {
      ...this.currentCreateDistributionChain,
      priceListId: this.currentCreateDistributionChain.priceListId ? this.currentCreateDistributionChain.priceListId : null,
      discountListId: this.currentCreateDistributionChain.discountListId ? this.currentCreateDistributionChain.discountListId : null,
      giftListId: this.currentCreateDistributionChain.giftListId ? this.currentCreateDistributionChain.giftListId : null,
    };

    const dataToSend: any = Object.entries(distributionChainData).reduce(
      (acc, [key, value]) => {
        if (value !== "" && !(Array.isArray(value) && value.length === 0)) {
          // Ignora cadenas vacías y arreglos vacíos
          acc[key] = value;
        }
        return acc;
      },
      {}
    );

    this.distributionChainService.create(dataToSend).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
        this.dialogRefAdd.close(true);
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updateDistributionChain(id: string): void {
    if (this.currentUpdateDistributionChain) {
      const updatedDistributionChain: IUpdateDistributionChain = {
        ...this.currentUpdateDistributionChain,
        companyId: this.currentUpdateDistributionChain.company._id.toString(),
        priceListId: this.currentUpdateDistributionChain.priceList ? this.currentUpdateDistributionChain.priceList._id.toString() : undefined,
        discountListId: this.currentUpdateDistributionChain.discountList ? this.currentUpdateDistributionChain.discountList._id.toString() : undefined,
        giftListId : this.currentUpdateDistributionChain.giftList ? this.currentUpdateDistributionChain.giftList._id.toString() : undefined,
        salesOrganizationId: this.currentUpdateDistributionChain.salesOrganization._id.toString(),
        channelId: this.currentUpdateDistributionChain.channel._id.toString(),
      };
      this.distributionChainService.update(id, updatedDistributionChain).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefEdit.close(true);
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  onStatusChange(event: boolean, warehouse: DistributionChainAttributes): void {
    const originalStatusId = warehouse.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedDistributionChain = {  statusId: updatedStatusId };

    this.distributionChainService
      .update(warehouse._id.toString(), updatedDistributionChain)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          warehouse.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  openDeleteDialog(warehouse: DistributionChainAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: warehouse, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(warehouse._id.toString()));
  }

  delete(id: string): void {
    this.distributionChainService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  
  onPriceSelectionChange(priceListId: string): void {
    if (this.currentUpdateDistributionChain) {
      this.currentUpdateDistributionChain.priceList = this.priceList.find(
        (price) => price._id.toString() === priceListId
      )!;
    }
  }

  onDiscountPriceSelectionChange(priceListId: string): void {
    if (this.currentUpdateDistributionChain) {
      this.currentUpdateDistributionChain.discountList = this.discountList.find(
        (price) => price._id.toString() === priceListId
      )!;
    }
  }

  onGiftPriceSelectionChange(giftListId: string): void {
    if (this.currentUpdateDistributionChain) {
      this.currentUpdateDistributionChain.giftList = this.giftList.find(
        (price) => price._id.toString() === giftListId
      )!;
    }
  }

  onCompanySelectionChange(companyid: string): void {
    if (this.currentUpdateDistributionChain) {
      this.currentUpdateDistributionChain.company = this.companyList.find(
        (price) => price._id.toString() === companyid
      )!;
    }
  }

  onSalesOrganizationSelectionChange(salesId: string): void {
    if (this.currentUpdateDistributionChain) {
      this.currentUpdateDistributionChain.salesOrganization = this.salesOrganizationList.find(
        (sales) => sales._id.toString() === salesId
      )!;
    }
  }

  onChannelSelectionChange(channelId: string): void {
    if (this.currentUpdateDistributionChain) {
      this.currentUpdateDistributionChain.channel = this.channelList.find(
        (channel) => channel._id.toString() === channelId
      )!;
    }
  }

  clearFilters(): void {
    this.searchQuery = "";
    this.form.reset({companyId: null, channelId: null});
    this.findAllWithCount();
  }
  
  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
